import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
export function ProblemSection() {
  const {
    ref,
    isVisible
  } = useScrollAnimation(0.1);
  return <section className="py-16 md:py-24 bg-[#0A0A0A] relative overflow-hidden" data-id="element-214">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" data-id="element-215" />

      <div className="container mx-auto px-4 max-w-4xl" data-id="element-216">
        <motion.div ref={ref} initial={{
        opacity: 0,
        y: 30
      }} animate={isVisible ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center mb-12 md:mb-16" data-id="element-217">
          <h2 className="text-3xl md:text-5xl font-bold mb-4 md:mb-6" data-id="element-218">
            El sistema actual está roto
          </h2>
          <p className="text-gray-400 text-lg md:text-xl" data-id="element-219">
            ¿Te suena familiar?
          </p>
        </motion.div>

        <div className="grid gap-4 md:gap-6 mb-12" data-id="element-220">
          {[{
          title: 'Prompting = Lento',
          desc: 'Pasás 3 horas escribiendo prompts para sacar 5 creativos mediocres. Mientras tanto, tu competencia ya lanzó 50.'
        }, {
          title: 'Tools Genéricas = Output Genérico',
          desc: 'Canva, Midjourney, ChatGPT... todo lindo, pero nada vende. Porque no están diseñados para ads que conviertan.'
        }, {
          title: 'Manual = Imposible',
          desc: 'Tu diseñador tarda una semana en entregar 10 creativos. Para cuando los tenés, el mercado ya cambió.'
        }].map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} animate={isVisible ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          delay: i * 0.2,
          duration: 0.5
        }} className="flex items-start gap-4 p-5 md:p-6 rounded-xl bg-white/5 border border-white/5 hover:border-red-500/30 transition-colors" data-id="element-221">
              <XCircle className="w-5 h-5 md:w-6 md:h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-222" />
              <div data-id="element-223">
                <h3 className="text-lg md:text-xl font-bold text-white mb-2" data-id="element-224">
                  {item.title}
                </h3>
                <p className="text-sm md:text-base text-gray-400" data-id="element-225">
                  {item.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={isVisible ? {
        opacity: 1,
        scale: 1
      } : {}} transition={{
        delay: 0.6,
        duration: 0.5
      }} className="bg-[#18181B] border-l-4 border-purple-500 p-6 md:p-8 rounded-r-xl relative overflow-hidden text-center" data-id="element-226">
          <div className="absolute inset-0 bg-purple-500/5 pointer-events-none" data-id="element-227" />
          <p className="text-lg md:text-2xl font-medium text-gray-200 relative z-10 mb-4" data-id="element-228">
            "Mientras vos perfeccionás un diseño, tu competencia ya testeó 50."
          </p>
          <a href="#pricing" className="text-purple-400 hover:text-purple-300 underline font-medium relative z-10" data-id="element-229">
            Hay una forma mejor →
          </a>
        </motion.div>
      </div>
    </section>;
}